import { connect } from 'react-redux'
import { listTableStyle } from '../../styles'
import { profilesActions, confirmActions, messageActions } from '../../actions'
import { reloadTable } from '../../utils/reloadTable'
import { withStyles } from '@material-ui/core/styles'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import CircularProgress from '@material-ui/core/CircularProgress'
import IconButton from '@material-ui/core/IconButton'
import ImageEdit from 'material-ui/svg-icons/image/edit'
import Paper from '@material-ui/core/Paper'
import React, { Component, Fragment } from 'react'
import TablePagination from '@material-ui/core/TablePagination'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Typography from '@material-ui/core/Typography'
import Undo from 'material-ui/svg-icons/content/undo'
import { findPermission, readOnly } from '../../utils/permissions'
import Visibility from '@material-ui/icons/Visibility'

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'

class ListTable extends Component {
  state = {
    debounce: undefined
  }

  componentWillUpdate(newProps) {
    const { pagination, order, fetchProfiles, term } = newProps
    const { page, rowsPerPage: perPage } = pagination

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchProfiles({ page, perPage, order, term })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }

  componentDidMount() {
    const { fetchProfiles } = this.props
    fetchProfiles()
  }

  handleChangePage = (event, page) => {
    const { handleChangePage } = this.props

    handleChangePage(page)
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    const { handleChangePerPage } = this.props

    handleChangePerPage(perPage)
  }

  handleSortTable = column => {
    const { order, changeOrderColumn, changeOrderDirection } = this.props

    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1

      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }

  renderActions = item => {
    const { fetchProfile, token, addConfirm, restoreProfile, deleteProfile } = this.props

    return (
      <Fragment>
        {readOnly('perfis', token) &&
          !item.deletedAt && (
            <IconButton
              onClick={() => {
                fetchProfile(item._id)
              }}
            >
              <Visibility nativeColor={'rgba(0, 0, 0, 0.87)'} />
            </IconButton>
          )}

        {!!item.deletedAt && findPermission('perfis', token).remover ? (
          <IconButton
            onClick={() => {
              const { changeMessage } = this.props

              addConfirm({
                confirmMessage: 'Confirma a restauração deste perfil?',
                confirmFunction: () => {
                  restoreProfile(item._id)
                  changeMessage({ message: 'Restauração realizada com sucesso.' })
                }
              })
            }}
          >
            <Undo />
          </IconButton>
        ) : (
          <Fragment>
            {findPermission('perfis', token).editar && (
              <IconButton
                onClick={() => {
                  fetchProfile(item._id)
                }}
              >
                <ImageEdit />
              </IconButton>
            )}

            {findPermission('perfis', token).remover && (
              <IconButton
                onClick={() => {
                  const { changeMessage } = this.props

                  addConfirm({
                    confirmMessage: 'Confirma a exclusão deste perfil?',
                    confirmFunction: () => {
                      deleteProfile(item._id)
                      changeMessage({ message: 'Exclusão realizada com sucesso.' })
                    }
                  })
                }}
              >
                <ActionDelete />
              </IconButton>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  }

  render() {
    const { classes, profiles = [], loadingProfiles, pagination, order = {} } = this.props

    return (
      <Paper className={classes.wrapperTable} elevation={4}>
        {!!loadingProfiles && (
          <div className={classes.wrapperLoader}>
            <CircularProgress />
          </div>
        )}

        <Table
          fixedHeader={true}
          width={'990px'}
          wrapperStyle={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'var(--crud-table-height)'
          }}
        >
          <TableHeader
            displaySelectAll={false}
            className={classes.tableHeader}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'nome'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('nome')
                  }}
                >
                  Nome
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '100px' }}>Ações</TableHeaderColumn>
            </TableRow>
          </TableHeader>

          <TableBody displayRowCheckbox={false} className={classes.tableBody}>
            {(profiles || []).length ? (
              (profiles || []).map(profile => {
                return (
                  <TableRow key={profile._id}>
                    <TableRowColumn>{profile.nome || '--'}</TableRowColumn>
                    <TableRowColumn style={{ width: '100px' }}>
                      {this.renderActions(profile)}
                    </TableRowColumn>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableRowColumn>
                  <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                    {!!loadingProfiles ? 'Carregando...' : 'Não há registros.'}
                  </Typography>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <div className={classes.paginationWrapper}>
          <div className={classes.page}>Página: {pagination.page + 1}</div>

          <TablePagination
            component="div"
            className={classes.pagination}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count, page }) => {
              return `Exibindo de ${from} a ${to} de ${count}`
            }}
            count={pagination.length}
            rowsPerPage={pagination.rowsPerPage}
            rowsPerPageOptions={[25, 50, 100]}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Página anterior'
            }}
            nextIconButtonProps={{
              'aria-label': 'Próxima página'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => {
  return {
    loadingProfiles: state.profiles.loadingProfiles,
    order: state.profiles.order,
    pagination: state.profiles.profilesPagination,
    profile: state.profiles.profile,
    profiles: state.profiles.profiles,
    term: state.searchTable.term,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(profilesActions.openModal())
    },
    closeModal: () => {
      dispatch(profilesActions.closeModal())
    },
    fetchProfile: id => {
      dispatch(profilesActions.fetchProfile(id))
    },
    fetchProfiles: options => {
      dispatch(profilesActions.fetchProfiles(options))
    },
    deleteProfile: id => {
      dispatch(profilesActions.deleteProfile(id))
    },
    handleChangePage: page => {
      dispatch(profilesActions.handleChangePage(page))
    },
    handleChangePerPage: perPage => {
      dispatch(profilesActions.handleChangePerPage(perPage))
    },
    addConfirm: ({ confirmMessage, confirmFunction }) => {
      dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction }))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    restoreProfile: id => {
      dispatch(profilesActions.restoreProfile(id))
    },
    changeOrderColumn: column => {
      dispatch(profilesActions.changeOrderColumn(column))
    },
    changeOrderDirection: direction => {
      dispatch(profilesActions.changeOrderDirection(direction))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(listTableStyle)(ListTable))



// WEBPACK FOOTER //
// ./src/containers/Profiles/ListTable.js